import type { QueryClient } from '@tanstack/react-query'
import { QUERY_KEY_CONFIG_COUNTRIES } from '@/lib/api/constants'

export const invalidateAfterImport = (queryClient: QueryClient) => {
  // drivers
  queryClient.invalidateQueries({ queryKey: ['drivers'] })
  queryClient.invalidateQueries({ queryKey: ['drivers-infinite'] })
  queryClient.invalidateQueries({ queryKey: ['basicDrivers'] })
  queryClient.invalidateQueries({ queryKey: ['driverGroups'] })
  queryClient.invalidateQueries({ queryKey: ['driver'] })

  // vehicles
  queryClient.invalidateQueries({ queryKey: ['vehicles'] })
  queryClient.invalidateQueries({ queryKey: ['vehicles-infinite'] })
  queryClient.invalidateQueries({ queryKey: ['vehicleGroups'] })
  queryClient.invalidateQueries({ queryKey: ['vehiclesInGroup'] })
  queryClient.invalidateQueries({ queryKey: ['vehiclesWithLocks'] })

  // alerts
  queryClient.invalidateQueries({ queryKey: ['alerts'] })

  // timesheets / activities / business-trips (business-trip data lives in grouped timesheet)
  queryClient.invalidateQueries({ queryKey: ['group-timesheet'] })
  queryClient.invalidateQueries({ queryKey: ['paged-group-timesheet'] })
  queryClient.invalidateQueries({ queryKey: ['amounts-preview'] })
  queryClient.invalidateQueries({ queryKey: ['foreign-amounts-preview'] })
  queryClient.invalidateQueries({ queryKey: ['bonus-configuration'] })
  queryClient.invalidateQueries({ queryKey: ['quarter-exchange-rate-status'] })

  // violations
  queryClient.invalidateQueries({ queryKey: ['groupedViolations'] })
  queryClient.invalidateQueries({ queryKey: ['creator-violations'] })

  // imported card-file history list (new rows appear after import)
  queryClient.invalidateQueries({ queryKey: ['QUERY_KEY_HISTORICAL_FILES'] })

  // IMI active-drivers list depends on the driver set
  queryClient.invalidateQueries({ queryKey: ['imiDeclaration'] })

  // dashboard aggregates the above
  queryClient.invalidateQueries({ queryKey: ['dashboard'] })

  queryClient.invalidateQueries({ queryKey: [QUERY_KEY_CONFIG_COUNTRIES] })
}
